/**
 * Grows a textarea to fit its content between a minimum and a maximum row
 * count, then lets it scroll past the maximum instead of clipping the text.
 * `params.value` carries no behaviour of its own: it exists so the action's
 * `update` fires whenever the bound value changes, including the async
 * populate from a loaded proposal, and not only on user `input`.
 *
 * @param {HTMLTextAreaElement} node
 * @param {{ minRows: number, maxRows: number, value?: string }} params
 */
export function autosize(node, params) {
  let current = params;

  function resize() {
    const style = getComputedStyle(node);
    const lineHeight = parseFloat(style.lineHeight) || 20;
    const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const minHeight = lineHeight * current.minRows + padding;
    const maxHeight = lineHeight * current.maxRows + padding;

    node.style.height = 'auto';
    const contentHeight = node.scrollHeight;
    node.style.height = `${Math.min(Math.max(contentHeight, minHeight), maxHeight)}px`;
    node.style.overflowY = contentHeight > maxHeight ? 'auto' : 'hidden';
  }

  node.addEventListener('input', resize);
  resize();

  return {
    update(newParams) {
      current = newParams;
      resize();
    },
    destroy() {
      node.removeEventListener('input', resize);
    }
  };
}
